import { DistrictAPIResponse } from 'src/app/private/shared/types/responses/district-list.responses';
import { State } from '../../utilities/enums/state.enum';
import { DistrictDTO } from '../district.dto';

export const districtDTOFromAPIResponse = (
  district: DistrictAPIResponse
): DistrictDTO => ({
  id: district.id,
  title: district.title,
  isDeleted: district.is_deleted,
  address: district.address,
  address2: district.address2,
  city: district.city,
  state: district.state as State,
  zip: district.zip,
  phone: district.phone,
  domain: district.domain,
  hubspotCompanyId: district.hubspot_company_id,
  districtCode: district.district_code,
  isB2b: district.is_b2b,
  isInternal: district.is_internal,
  logo: district.logo,
  timezone: district.timezone,
  counts: {
    users: district.counts?.users || 0,
    schools: district.counts?.schools || 0,
  },
  reportingSchoolYear: district.reporting_school_year,
  // TODO: Add schools
});
